
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/about",
      function () {
        return require("private-next-pages/company/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/about"])
      });
    }
  